import { render, staticRenderFns } from "./SubscriberPaidServices.vue?vue&type=template&id=231fb856&scoped=true"
import script from "./SubscriberPaidServices.vue?vue&type=script&lang=js"
export * from "./SubscriberPaidServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231fb856",
  null
  
)

export default component.exports